import React from 'react'
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied'
import { Grid, Stack, SxProps, Theme, Typography } from '@mui/material'
import ColorBox from 'common/Box/ColorWhiteBox'
const defaultHeaderSx = { fontSize: 14, fontWeight: 400, color: '#818D9C' }
const defaultBodySx = { fontSize: 24, fontWeight: 700 }

export function StatsCards(props: StatsCardsProps) {
  const { totals, headerSx, bodySx, icon, bad } = props

  const displayedHeaderSx: SxProps<Theme> = headerSx
    ? { ...defaultHeaderSx, ...headerSx }
    : defaultHeaderSx

  const displayedBodySx: SxProps<Theme> = bodySx
    ? { ...defaultBodySx, ...bodySx }
    : defaultBodySx

  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='center'
      columnSpacing={1}
      rowSpacing={2}
      style={{ marginBottom: 20 }}
    >
      {totals.length > 0 &&
        totals.map((item, index) => (
          <Grid
            item
            xs={totals.length > 0 ? 12 / totals.length : 3}
            key={index}
          >
            <ColorBox>
              <Grid
                container
                direction='row'
                justifyContent='flex-start'
                alignItems='center'
                columnSpacing={3}
                gap={2}
              >
                <Grid item xs={1}>
                  {bad && index === 1 ? (
                    <SentimentVeryDissatisfiedIcon color='primary' />
                  ) : icon ? (
                    icon
                  ) : (
                    <SentimentSatisfiedAltIcon color='primary' />
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Stack spacing={0.5} alignItems='flex-start'>
                    <Typography
                      sx={{ ...displayedHeaderSx, ml: 0, mb: '-2px' }}
                    >
                      {item.title}
                    </Typography>
                    {item.data.map((line, index) => {
                      return (
                        <Typography key={index} sx={displayedBodySx}>
                          {line}
                        </Typography>
                      )
                    })}
                  </Stack>
                </Grid>
              </Grid>
            </ColorBox>
          </Grid>
        ))}
    </Grid>
  )
}

export interface DisplayTotals {
  title: string
  data: string[]
}

export interface StatsCardsProps {
  totals: DisplayTotals[]
  headerSx?: SxProps<Theme>
  bodySx?: SxProps<Theme>
  icon?: JSX.Element
  bad?: boolean
}
